<template>
  <div v-if="masterCampaign">
    <vs-tabs position="left" class="tabs-shadow-none mt-2" id="profile-tabs" :key="isSmallerScreen">
      <vs-tab icon-pack="feather" icon="icon-zap" :label="!isSmallerScreen ? 'General' : ''">
        <div class="lists-view-tab">
          <master-campaign-general
            :master-campaign="masterCampaign"
            v-on:onSave="$emit('onSave')"
            :isEditable="isEditable && $AuthService.hasPermissionForActiveVenue('vp.crm.campaigns.edit')"
          />
        </div>
      </vs-tab>
      <vs-tab
        :disabled="!hasEmail"
        icon-pack="feather"
        icon="icon-mail"
        :label="!isSmallerScreen ? 'Email Template' : ''"
      >
        <div class="lists-view-tab">
          <master-campaign-email
            :master-campaign="masterCampaign"
            v-on:onSave="$emit('onSave')"
            :isEditable="isEditable && $AuthService.hasPermissionForActiveVenue('vp.crm.campaigns.edit')"
          />
        </div>
      </vs-tab>
      <vs-tab
        :disabled="!hasSms"
        icon-pack="feather"
        icon="icon-smartphone"
        :label="!isSmallerScreen ? 'Sms Template' : ''"
      >
        <div class="lists-view-tab">
          <master-campaign-sms :master-campaign="masterCampaign" v-on="$listeners" :isEditable="isEditable" />
        </div>
      </vs-tab>
      <vs-tab icon-pack="feather" icon="icon-alert-triangle" :label="!isSmallerScreen ? 'Danger Zone' : ''">
        <div class="lists-view-tab">
          <master-campaign-danger-zone
            :master-campaign="masterCampaign"
            v-on:onSave="$emit('onSave')"
            :isEditable="isEditable && $AuthService.hasPermissionForActiveVenue('vp.crm.campaigns.edit')"
          />
        </div>
      </vs-tab>
    </vs-tabs>
  </div>
</template>

<script>
import MasterCampaignGeneral from "./Step1/MasterCampaignGeneral.vue";
import MasterCampaignEmail from "./Step1/MasterCampaignEmail.vue";
import MasterCampaignSms from "./Step1/MasterCampaignSms.vue";
import MasterCampaignDangerZone from "./Step1/MasterCampaignDangerZone.vue";

export default {
  props: ["masterCampaign", "isEditable"],
  components: {
    MasterCampaignGeneral,
    MasterCampaignEmail,
    MasterCampaignSms,
    MasterCampaignDangerZone,
  },
  computed: {
    hasEmail() {
      return this.masterCampaign.hasEmail;
    },
    hasSms() {
      return this.masterCampaign.hasSms;
    },
    isSmallerScreen() {
      return this.$store.state.windowWidth < 768;
    },
  },
};
</script>